/* eslint-disable */

import { getKinesisTracker } from '@/tracker/provider';

/**
 * `packages/protobuf-log/dist/typescript/clientlogs/home-common-txtpb.ts` 의
 * CATEGORY_OVERVIEW 영역만 발췌. infra-protobuf 변경 시 dist 최신본을 보고
 * 이 파일의 카테고리 namespace 만 수동 sync.
 */

/**
 * PageName: CATEGORY_OVERVIEW
 */
export const CategoryOverviewPageLog = {
  Unspecified: {
    /**
     * 홈 - 전체 카테고리 - 진입
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L1157}
     */
    view(_args: CategoryOverviewPageLog.Unspecified.View = {}) {
      const kinesisTracker = getKinesisTracker();

      return kinesisTracker.view('CATEGORY_OVERVIEW', {
        inactive: false,
        clientEventId: 669,
        pageName: 'PAGE_NAME_CATEGORY_OVERVIEW',
        eventType: 'EVENT_TYPE_VIEW',
      });
    },
  },

  ButtonCategoryTitle: {
    /**
     * 홈 - 전체 카테고리 - 클릭 - 상품유형(대분류) - 버튼
     * (PCweb) https://screen.yanolja.in/afVJRyPrsL3Z6WsD.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L1166}
     * CategoryOverviewCategoryHeader
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/feapi/clientlog/home/category_overview.proto#L11}
     */
    click({ logMeta }: CategoryOverviewPageLog.ButtonCategoryTitle.Click) {
      const kinesisTracker = getKinesisTracker();

      return kinesisTracker.click('CATEGORY_OVERVIEW', {
        inactive: false,
        clientEventId: 671,
        pageName: 'PAGE_NAME_CATEGORY_OVERVIEW',
        object: 'CategoryTitle',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  CategoryTitleButtonSub: {
    /**
     * 홈 - 전체 카테고리 - 클릭 - 상품유형(중분류) - 버튼
     * (PCweb) https://screen.yanolja.in/afVJRyPrsL3Z6WsD.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/home/common.txtpb#L1180}
     * CategoryOverviewItem
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/feapi/clientlog/home/category_overview.proto#L25}
     */
    click({ logMeta }: CategoryOverviewPageLog.CategoryTitleButtonSub.Click) {
      const kinesisTracker = getKinesisTracker();

      return kinesisTracker.click('CATEGORY_OVERVIEW', {
        inactive: false,
        clientEventId: 672,
        pageName: 'PAGE_NAME_CATEGORY_OVERVIEW',
        object: 'subCategoryTitle',
        objectContainer: 'categoryTitle',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CategoryOverviewPageLog {
  export namespace Unspecified {
    /**
     */
    export interface View {}
  }
  export namespace ButtonCategoryTitle {
    /**
     * (PCweb) https://screen.yanolja.in/afVJRyPrsL3Z6WsD.png
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace CategoryTitleButtonSub {
    /**
     * (PCweb) https://screen.yanolja.in/afVJRyPrsL3Z6WsD.png
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
}
